import axios from "axios";
import en from "@/content/en";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : null;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validate = (v, t, { needService = false } = {}) => {
  const e = {};
  ["company", "contact_name", "email"].forEach((k) => { if (!v[k]?.trim()) e[k] = t.quote.required; });
  if (v.email?.trim() && !EMAIL_RE.test(v.email.trim())) e.email = t.quote.invalidEmail;
  if (needService && !(v.services?.length > 0)) e.services = t.quote.pickService;
  return e;
};

export async function submitEnquiry(kind, lang, values, files = []) {
  if (!API) throw new Error("Backend not configured");
  const fd = new FormData();
  fd.append("kind", kind);
  fd.append("lang", lang);
  Object.entries(values).forEach(([k, v]) => {
    if (k === "services") (v || []).forEach((slug) => fd.append("services", en.services.find((s) => s.slug === slug)?.title || slug));
    else if (v) fd.append(k, v);
  });
  files.forEach((f) => fd.append("files", f));
  const res = await axios.post(`${API}/enquiries`, fd);
  return res.data?.id ?? "";
}

export const errMsg = (err, fallback) => {
  const d = err?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};
